import { render, staticRenderFns } from "./CopyrightPopupDetails.vue?vue&type=template&id=77033c02&scoped=true&"
import script from "./CopyrightPopupDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightPopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightPopupDetails.vue?vue&type=style&index=0&id=77033c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77033c02",
  null
  
)

export default component.exports